import React from 'react';
import PropTypes from 'prop-types';
import { faGraduationCap } from '@fortawesome/pro-solid-svg-icons';

// Base
import CircledIcon from '../../../../../base/circled_icon';

export default class Show extends React.Component {
  static propTypes = {
    educationEntry: PropTypes.object.isRequired,
  }

  render() {
    const { educationEntry } = this.props;
    return (
      <div className='flex'>
        <div>
          <CircledIcon {...{
            icon: faGraduationCap,
            className: 'primary-color flex-shrink-0',
          }} />
        </div>
        <div className='flex-row margin-left-10'>
          <div>
            {educationEntry.institution}
          </div>
          <div className='xsm-font gray-900'>
            {educationEntry.field_of_study} - {educationEntry.education_level_name}
          </div>
          <div className='xxsm-font gray-900'>
            {educationEntry.start_year}
            <span className='margin-left-5 margin-right-5'>-</span>
            {educationEntry.end_year}
          </div>
        </div>
      </div>
    )
  }
}